import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star, Shield, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceAreas = [
    { name: 'Dothan', path: '/service-areas/dothan-al' },
    { name: 'Enterprise', path: '/service-areas/enterprise-al' },
    { name: 'Ozark', path: '/service-areas/ozark-al' },
    { name: 'Geneva', path: '/service-areas/geneva-al' },
    { name: 'Headland', path: '/service-areas/headland-al' },
    { name: 'Midland City', path: '/service-areas/midland-city-al' },
    { name: 'Daleville', path: '/service-areas/daleville-al' },
    { name: 'Newton', path: '/service-areas/newton-al' },
    { name: 'Rehobeth', path: '/service-areas/rehobeth-al' },
  ];

  const services = [
    { name: 'Plumbing Services', path: '/services/plumbing' },
    { name: 'Electrical Services', path: '/services/electrical' },
    { name: 'Residential Services', path: '/services/residential' },
    { name: 'Commercial Services', path: '/services/commercial' },
  ];

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact-us' },
    { name: 'Book Online', path: '/contact-us' },
  ];

  return (
    <footer className="bg-brand-navy text-white">
      {/* Main Footer */}
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo.png"
                alt="Ard's Plumbing & Electric"
                width="1280"
                height="702"
                className="h-12 lg:h-14 w-auto"
              />
            </div>
            <p className="text-white/80 mb-6 text-sm leading-relaxed">
              Fast fixes. Lasting work. Real people. Serving the Wiregrass area with reliable plumbing and electrical services for over 65 years.
            </p>
            <div className="space-y-3">
              <a href="tel:3346925537" className="flex items-center gap-3 text-white/80 hover:text-brand-yellow transition-colors">
                <Phone className="w-4 h-4" />
                <span>(334) 692-5537</span>
              </a>
              <a href="mailto:support@ardsdothan.com" className="flex items-center gap-3 text-white/80 hover:text-brand-yellow transition-colors">
                <Mail className="w-4 h-4" />
                <span>support@ardsdothan.com</span>
              </a>
              <div className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Newton, AL 36352</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-white/70 hover:text-brand-yellow transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Service Areas</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/service-areas" className="text-white/70 hover:text-brand-yellow transition-colors text-sm font-semibold">
                  All Service Areas →
                </Link>
              </li>
              {serviceAreas.map((area) => (
                <li key={area.path}>
                  <Link
                    to={area.path}
                    className="text-white/70 hover:text-brand-yellow transition-colors text-sm"
                  >
                    {area.name}, AL
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links & Trust Badges */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 mb-6">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-brand-yellow transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="space-y-3">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Shield className="w-4 h-4 text-brand-yellow" />
                <span>Licensed & Insured</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Star className="w-4 h-4 text-brand-yellow" />
                <span>4-Star Rated</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Clock className="w-4 h-4 text-brand-yellow" />
                <span>Mon-Fri 8AM-5PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {currentYear} Ard's Plumbing & Electric. All rights reserved. Licensed & Insured.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/terms-of-service" className="text-white/60 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy-policy" className="text-white/60 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
